import { useQuery } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";

const useOrderDetail = (orderId) => {
  const { token } = useContext(AuthContext);

  return useQuery(
    ["orderDetail", orderId],
    async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/order/orders/${orderId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return res.data;
    },
    { enabled: !!orderId && !!token }
  );
};

export default useOrderDetail;
